import { storageService } from "./storageService";

export interface UploadResponse {
  url: string;
  filename: string;
  size: number;
  contentType: string;
}

class FileUploadService {
  private readonly ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];

  private validateFile(file: File): void {
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      throw new Error("Invalid file type. Only JPG, PNG, GIF, and WebP images are allowed.");
    }
  }

  async uploadFile(file: File): Promise<UploadResponse> {
    this.validateFile(file);

    const result = await storageService.uploadFile(file, "uploads", "images");
    if (result.error || !result.url) {
      throw new Error(result.error || "Upload failed");
    }

    const filename = result.path.split("/").pop() || `upload_${Date.now()}`;

    return {
      url: result.url,
      filename,
      size: file.size,
      contentType: file.type,
    };
  }

  async deleteFile(url: string): Promise<void> {
    if (!url) {
      return;
    }

    const result = await storageService.deleteFile(url);
    if (result.error) {
      throw new Error(result.error);
    }
  }

  revokeUrl(url: string): void {
    if (url.startsWith("blob:")) {
      URL.revokeObjectURL(url);
    }
  }
}

export const fileUploadService = new FileUploadService();
